module.exports = __webpack_public_path__ + "static/img/student_4.abfced35.png";